import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { usePermissions } from '../../contexts/PermissionsContext';
import { CollaboratorProfile } from '../../services/collaboratorProfileApi';
import { getMyTeamMemberProfile } from '../../services/myTeamApi';

function Field({ label, value }: { label: string; value?: string | null }) {
  return (
    <div>
      <p className="text-xs uppercase tracking-wide text-secondary-500">{label}</p>
      <p className="mt-1 text-sm text-secondary-900">{value?.trim() || '—'}</p>
    </div>
  );
}

export function MyTeamMemberProfilePage() {
  const { userId } = useParams();
  const { canAccessModule } = usePermissions();
  const canOpenAdminProfile = canAccessModule('access-control.users');
  const [profile, setProfile] = useState<CollaboratorProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    void (async () => {
      setLoading(true);
      try {
        setProfile(await getMyTeamMemberProfile(userId));
      } catch {
        toast.error('Falha ao carregar o cadastro do colaborador.');
        setProfile(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [userId]);

  return (
    <PageShell>
      <PageHeader
        title={loading ? 'Carregando cadastro...' : profile?.userName ?? 'Colaborador'}
        description="Cadastro do colaborador no escopo da sua equipe (somente leitura)."
        actions={(
          <div className="flex flex-wrap gap-2">
            {canOpenAdminProfile && userId ? (
              <Link to={`/admin/users/${userId}/profile`} className="erp-btn-secondary text-sm">
                Abrir cadastro completo
              </Link>
            ) : null}
            <Link to="/people/my-team" className="erp-btn-secondary text-sm">
              Voltar
            </Link>
          </div>
        )}
      />

      {loading ? (
        <p className="text-secondary-500">Carregando cadastro...</p>
      ) : !profile ? (
        <p className="text-secondary-500">Cadastro não encontrado ou sem permissão.</p>
      ) : (
        <section className="rounded-xl border border-secondary-200 bg-white p-4">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <Field label="Nome" value={profile.userName} />
            <Field label="CPF" value={profile.cpf} />
            <Field label="Cargo" value={profile.jobPositionName} />
            <Field label="Nível" value={profile.jobLevel} />
            <Field label="Tipo de vínculo" value={profile.employmentType} />
            <Field label="E-mail pessoal" value={profile.personalEmail} />
            <Field label="Telefone" value={profile.phone} />
            <Field label="Cidade" value={profile.city} />
            <Field label="UF" value={profile.state} />
            <Field label="Estado civil" value={profile.maritalStatus} />
          </div>
        </section>
      )}
    </PageShell>
  );
}
